import React from 'react';
import { DatePicker, DatePickerProps } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/core/styles';
import ArrowBackIosSharpIcon from '@material-ui/icons/ArrowBackIosSharp';
import ArrowForwardIosSharpIcon from '@material-ui/icons/ArrowForwardIosSharp';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

import { theme } from './theme';

export interface BaseDatePickerProps extends DatePickerProps {
  closeOnChange?: boolean;
}

export const BaseDatePicker = ({ onChange, views, closeOnChange = true, ...props }: BaseDatePickerProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const wrappedOnChange = React.useCallback(
    (date: MaterialUiPickersDate) => {
      onChange(date);
      if (closeOnChange) {
        setIsOpen(false);
      }
    },
    [onChange, closeOnChange]
  );

  const handleOpen = React.useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleYearChange = React.useCallback(() => {
    if (!closeOnChange) {
      setIsOpen(false);
    }
  }, [closeOnChange]);

  const handleClose = React.useCallback(() => setIsOpen(false), []);

  return (
    <ThemeProvider theme={theme}>
      <DatePicker
        variant="inline"
        leftArrowIcon={<ArrowBackIosSharpIcon />}
        rightArrowIcon={<ArrowForwardIosSharpIcon />}
        onChange={wrappedOnChange}
        onOpen={handleOpen}
        onYearChange={handleYearChange}
        open={isOpen}
        views={views}
        onClose={handleClose}
        {...props}
      />
    </ThemeProvider>
  );
};
